import {playPigSound} from "@/utils/audio";
import {memo} from "react";
import {isSafari} from "@/utils/detectors";

const Spinner = () => {
  const playSound = (event: React.MouseEvent) => {
    const element = event.currentTarget as HTMLElement;
    element.style.scale = "1.5";

    const audio = playPigSound("random");

    audio.addEventListener("ended", () => {
      element.removeAttribute("style");
    });
  };

  if (isSafari) {
    return (
      <div className="spinner spinner--lg absolute inset-0 m-auto size-32 cursor-pointer transition"></div>
    );
  }

  return (
    <video
      className="absolute inset-0 m-auto size-32 cursor-pointer transition"
      src="/images/pig.webm"
      muted
      autoPlay
      playsInline
      loop
      onClick={playSound}
    />
  );
};

export default memo(Spinner);
